
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lottery",
      function () {
        return require("private-next-pages/lottery/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lottery"])
      });
    }
  